import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const femaleNames = ['Ana', 'Maria', 'Juliana', 'Fernanda', 'Camila', 'Beatriz', 'Carolina', 'Gabriela', 'Mariana', 'Patricia', 'Rafaela', 'Larissa', 'Leticia', 'Amanda', 'Bruna', 'Daniela', 'Vanessa', 'Priscila', 'Tatiana', 'Renata', 'Luciana', 'Adriana', 'Carla', 'Paula', 'Bianca', 'Jessica', 'Aline', 'Cristina', 'Debora', 'Elaine'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  useEffect(() => {
    const showNotification = () => {
      // Pick random name
      const randomName = femaleNames[Math.floor(Math.random() * femaleNames.length)];
      setCurrentName(randomName);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(showNotification, 3000);
    // Then show every 15 seconds
    const interval = setInterval(showNotification, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-369">
      {isVisible && <div className="fixed bottom-6 left-0 right-0 z-50 flex justify-center px-4" data-id="element-370">
          <motion.div initial={{
        opacity: 0,
        y: 50,
        scale: 0.8
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 50,
        scale: 0.8
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="w-full max-w-sm" data-id="element-371">
            <div className="bg-white rounded-xl shadow-2xl border-2 border-green-200 p-4 flex items-start gap-3" data-id="element-372">
              <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center" data-id="element-373">
                <ShoppingBag className="w-5 h-5 text-white" data-id="element-374" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-375">
                <p className="text-sm font-bold text-stone-900 mb-0.5" data-id="element-376">
                  {currentName}
                </p>
                <p className="text-xs text-stone-600" data-id="element-377">
                  Acabou de comprar o Efeito Boutique!
                </p>
              </div>
              <button onClick={() => setIsVisible(false)} className="flex-shrink-0 text-stone-400 hover:text-stone-600 transition-colors" data-id="element-378">
                <X className="w-4 h-4" data-id="element-379" />
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}